module.exports = __webpack_public_path__ + "media/images/flags/64/Czech-Republic-96d141cbd61787aa7b51fbfd248fd459.png";